"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOpSchedule = void 0;
function validateOpSchedule(s) {
    var _a, _b;
    if (s.whenCanView < s.whenCanStart)
        return false;
    return (s.allPlacesPermitted ||
        (!s.placesSelectedByTag && !!((_a = s.places) === null || _a === void 0 ? void 0 : _a.length)) ||
        (s.placesSelectedByTag && !!((_b = s.placeTags) === null || _b === void 0 ? void 0 : _b.length)));
}
exports.validateOpSchedule = validateOpSchedule;
exports.default = validateOpSchedule;
